module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module id = 244
// module chunks = 0